import { HighScores, SCORE_KEY } from './HighScores.mjs';
import { Input } from './Input';

const $ = id => document.getElementById(id);
export const HighScoresUI = {
    init() {
        $('score-name-form').addEventListener('submit', event => { event.preventDefault(); this.finish(true); });
        $('score-skip').addEventListener('click', () => this.finish(false));
        $('score-dialog').addEventListener('cancel', event => { event.preventDefault(); this.finish(false); });
        window.addEventListener('ladder-high-score', event => {
            this.offer(event.detail.entry);
        });
        window.addEventListener('storage', event => {
            if (event.key === SCORE_KEY || event.key === null) { HighScores.reload(); this.render(); }
        });
        this.render();
    },

    offer(entry) {
        if (this.pending) return;
        if (!HighScores.qualifies(entry)) {
            $('high-score-result').textContent = `Game over: ${entry.score.toLocaleString()} points. Your local top ten is unchanged.`;
            return;
        }
        this.pending = { ...entry };
        this.wasSuspended = Input.suspended;
        Input.suspended = true;
        Input.consume(true);
        $('score-dialog-summary').textContent = `${entry.score.toLocaleString()} points · Level ${entry.level} · Original campaign`;
        $('score-player').value = HighScores.name === 'Player' ? '' : HighScores.name;
        $('high-score-result').textContent = '';
        $('score-dialog').showModal();
        $('score-player').focus();
        $('score-player').select();
    },

    finish(save) {
        if (!this.pending) return;
        const entry = this.pending;
        this.pending = null;
        if (save) {
            HighScores.setName($('score-player').value);
            entry.name = HighScores.name;
            const ranked = HighScores.add(entry);
            $('high-score-result').textContent = ranked
                ? `${entry.name}: ${entry.score.toLocaleString()} points — added to your local top ten.`
                : 'Another score filled the top ten while you were entering your name. This score did not qualify.';
        } else {
            $('high-score-result').textContent = `Game over: ${entry.score.toLocaleString()} points. Score not saved.`;
        }
        $('score-dialog').close();
        Input.consume(true);
        Input.suspended = this.wasSuspended;
        this.render();
        $('canvas').focus({ preventScroll: true });
    },

    render() {
        $('high-score-rows').replaceChildren(...HighScores.entries.map((entry, index) => {
            const row = document.createElement('tr');
            for (const value of [index + 1, entry.name, entry.score.toLocaleString(), entry.level, entry.speed, new Date(entry.date).toLocaleDateString()]) {
                const cell = document.createElement('td');
                cell.textContent = value;
                row.append(cell);
            }
            return row;
        }));
        $('high-score-empty').hidden = HighScores.entries.length > 0;
        $('high-score-table').hidden = HighScores.entries.length === 0;
        $('high-score-storage').textContent = HighScores.warning;
        $('high-score-storage').hidden = !HighScores.warning;
    }
};
